// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inventory_content__WkUGE {
  position: relative; }
  .inventory_content__WkUGE .inventory_header__9\\+lZX {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 40px; }
  .inventory_content__WkUGE .inventory_body__iYssK {
    height: calc(100vh - 110px);
    display: flex;
    gap: 10px;
    margin-top: 20px; }
    .inventory_content__WkUGE .inventory_body__iYssK .inventory_noInventoryItem__85cku {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 10px; }
      .inventory_content__WkUGE .inventory_body__iYssK .inventory_noInventoryItem__85cku .inventory_title__aNfuz {
        font-weight: 700;
        font-size: 18px;
        line-height: 24px;
        color: var(--HightEmphasis); }
      .inventory_content__WkUGE .inventory_body__iYssK .inventory_noInventoryItem__85cku .inventory_subtitle__Ay9vO {
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        color: var(--MediumEmphasis); }

.inventory_title__aNfuz {
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 32px;
  line-height: 150%;
  color: var(--HightEmphasis);
  gap: 30px; }
  .inventory_title__settings__YDJ-H {
    margin-left: 7px;
    color: #666666;
    cursor: pointer;
    transition: all 0.4s linear;
    width: 32px;
    height: 32px; }
    .inventory_title__settings__YDJ-H:hover {
      color: black; }
`, "",{"version":3,"sources":["webpack://./src/pages/inventory/inventory.module.scss","webpack://./src/styles/fonts.scss"],"names":[],"mappings":"AAGA;EACE,kBAAkB,EAAA;EADpB;IAGI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB,EAAA;EANvB;IASI,2BAA2B;IAC3B,aAAa;IACb,SAAS;IACT,gBAAgB,EAAA;IAZpB;MAeM,aAAa;MACb,sBAAsB;MACtB,uBAAuB;MACvB,mBAAmB;MACnB,SAAS,EAAA;MAnBf;QCUE,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QDWX,2BAA2B,EAAA;MAvBnC;QCkCE,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QDRX,4BAA4B,EAAA;;AAKpC;EACE,aAAa;EACb,mBAAmB;ECrCnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EDqCjB,2BAA2B;EAC3B,SAAQ,EAAA;EACR;IACE,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,2BAA2B;IAC3B,WAAW;IACX,YAAY,EAAA;IANb;MAQG,YAAW,EAAA","sourcesContent":["@import '../../styles/media.scss';\n@import '../../styles/fonts.scss';\n\n.content {\n  position: relative;\n  .header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 40px;\n  }\n  .body {\n    height: calc(100vh - 110px);\n    display: flex;\n    gap: 10px;\n    margin-top: 20px;\n\n    .noInventoryItem {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n      gap: 10px;\n\n      .title {\n        @include h3;\n        color: var(--HightEmphasis);\n      }\n\n      .subtitle {\n        @include body1;\n        color: var(--MediumEmphasis);\n      }\n    }\n  }\n}\n.title {\n  display: flex;\n  align-items: center;\n  @include h1;\n  color: var(--HightEmphasis);\n  gap:30px;\n  &__settings {\n    margin-left: 7px;\n    color: #666666;\n    cursor: pointer;\n    transition: all 0.4s linear;\n    width: 32px;\n    height: 32px;\n    &:hover{\n      color:black;\n    }\n  }\n}\n","@mixin h1 {\n  font-weight: 600;\n  font-size: 32px;\n  line-height: 150%;\n}\n\n@mixin h2 {\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 150%;\n}\n\n@mixin h3 {\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n}\n\n@mixin h4 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin h5 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin h6 {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin body1 {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin body2 {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n}\n\n@mixin body3 {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n}\n\n@mixin link1 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin link2 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin caption {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 24px;\n}\n\n@mixin title {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin button {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `inventory_content__WkUGE`,
	"header": `inventory_header__9+lZX`,
	"body": `inventory_body__iYssK`,
	"noInventoryItem": `inventory_noInventoryItem__85cku`,
	"title": `inventory_title__aNfuz`,
	"subtitle": `inventory_subtitle__Ay9vO`,
	"title__settings": `inventory_title__settings__YDJ-H`
};
export default ___CSS_LOADER_EXPORT___;
